import styled from "styled-components";
import { gnbConst } from "../constants/gnbConst";
import { BoxButtonTitle, CommmonBoxLayout, CommonLayout, FlexBox, InputLinkBox } from "../style/common";
import TitleAndInput from "../components/common/TitleAndInput";
import Btn from "../components/common/Btn";
import { useEffect, useState } from "react";
import { getTaskList, putTaskList } from "../api/task";
import { stringToJson } from "../utils/stringToJson";
import { getSettings, postSettings } from "../api/settings";
import { useAlertStore } from "../store/alertStore";
import { memberChangePw, memberList } from "../api/member";
import { useMemberStore } from "../store/memberStore";
import { useNavigatePage } from "../hooks/useNavigatePage";

export default function Setting() {
  const pageTitle = gnbConst[6].title;
  const { memberPermitLevel } = useMemberStore();
  const { onMovementPage } = useNavigatePage();
  const setAlert = useAlertStore((state) => state.setAlert);
  const [settingsData, getSettingsData] = useState<SettingsResponse>();
  const [taskData, getTaskData] = useState<GetTaskListResponse>();
  const [apiKey, setApiKey] = useState("");
  const [promptVal, setPromptVal] = useState("");
  const [modelVal, setModelVal] = useState("");
  const [adminObj, setAdminObj] = useState<MemberListUserItem>();
  const [admin2Obj, setAdmin2Obj] = useState<MemberListUserItem>();
  const [adminPw, setAdminPw] = useState("");
  const [admin2Pw, setAdmin2Pw] = useState("");

  useEffect(() => {
    if (gnbConst[0].level > memberPermitLevel) {
      alert("접근 권한이 없습니다.");
      onMovementPage(-1);
    }
  }, [memberPermitLevel]);

  useEffect(() => {
    const apiGetTaskList = async () => {
      try {
        const memberListProps = {
          search: "200",
          search_field: "member_permit_level",
        };

        const [
          taskResponse,
          settingsResponse,
          adminResponse,
        ] = await Promise.all([
          getTaskList(),
          getSettings(),
          memberList(memberListProps),
        ]);

        if (taskResponse.statusCode === 200) {
          const taskData = taskResponse.list[0];

          if (taskData.task_params) {
            getTaskData(taskResponse);

            const taskParams = stringToJson(taskData.task_params);
            setPromptVal(taskParams.prompt || "");
            setModelVal(taskParams.model || "gpt-3.5-turbo");
          }
        }

        if (settingsResponse.statusCode === 200) {
          getSettingsData(settingsResponse);
          setApiKey(settingsResponse.data?.openai_key || "");
        }

        if (adminResponse.statusCode === 200) {
          const adminResponseList = adminResponse.list;

          if (adminResponseList) {
            for (let adminItem of adminResponseList) {
              adminItem.member_id === "admin" ? setAdminObj(adminItem) : setAdmin2Obj(adminItem);
            }
          }
        }
      } catch (error) { }
    };

    apiGetTaskList();
  }, []);

  const apiPutClick = async () => {
    try {
      const task_params = { prompt: promptVal, model: modelVal };
      const taskPropsData = {
        idx: taskData?.list[0].idx,
        task_idx: taskData?.list[0].task_idx,
        module_idx: taskData?.list[0].module_idx,
        task_params: JSON.stringify(task_params),
      };

      const settingsPropsData = {
        ...settingsData,
        openai_key: apiKey,
      }

      const [
        taskResponse,
        settingsResponse,
      ] = await Promise.all([
        putTaskList(taskPropsData),
        postSettings(settingsPropsData),
      ]);

      if (taskResponse.statusCode === 200 && settingsResponse.statusCode === 200) {
        setAlert("AI용 모델 API KEY 설정이 변경되었습니다.", "green");
      }
    } catch (error) { }
  }

  const apiPutAdminClick = async () => {
    try {
      const adminPwVal = adminPw.trim();
      const admin2PwVal = admin2Pw.trim();
      if (adminPwVal === "" && admin2PwVal === "") {
        setAlert("비밀번호를 입력해주세요.", "red");
        return;
      }

      let responseBool = false;

      if (adminPwVal !== "") {
        if (adminObj?.idx) {
          const adminIdx = adminObj?.idx;
          const memberChangePwProps = { idx: adminIdx as string, member_pw: adminPw };

          const response = await memberChangePw(memberChangePwProps);

          if (response.statusCode !== 200) {
            setAlert("새로고침 후 다시 시도해주세요.", "red");
            return;
          }
        } else {
          setAlert("새로고침 후 다시 시도해주세요.", "red");
          return;
        }
      }

      if (admin2PwVal !== "") {
        if (admin2Obj?.idx) {
          const admin2Idx = admin2Obj?.idx;
          const memberChangePwProps = { idx: admin2Idx as string, member_pw: admin2Pw };

          const response = await memberChangePw(memberChangePwProps);

          if (response.statusCode !== 200) {
            setAlert("새로고침 후 다시 시도해주세요.", "red");
            return;
          }
        } else {
          setAlert("새로고침 후 다시 시도해주세요.", "red");
          return;
        }
      }

      responseBool = true;

      if (responseBool) {
        setAlert("관리자 비밀번호가 변경되었습니다.", "green");
      }
    } catch (error) { }
  }

  return (
    <CommonLayout>
      <CommmonBoxLayout>
        <SettingBox>
          <BoxButtonTitle>
            {pageTitle}
            <Btn type="button" title="저장" color="blue" onClick={apiPutAdminClick} />
          </BoxButtonTitle>

          <InputLinkBox>
            <TitleAndInput
              title="관리자 아이디"
              type="none"
              value={adminObj?.member_id || ""}
              placeholder="관리자 아이디"
            />
            <TitleAndInput
              title="비밀번호"
              type="password"
              value={adminPw}
              onChange={(e) => setAdminPw(e.target.value)}
              placeholder="관리자 비밀번호"
            />
            {/* <PhoneCheckBox as="form" onSubmit={onPhoneSubmit}>
              <TitleAndInput
                title="휴대전화 인증"
                type="text"
                placeholder="- 없이 입력"
              />
              <Btn type="submit" title="인증" color="gray" />
            </PhoneCheckBox> */}
          </InputLinkBox>

          <InputLinkBox>
            <TitleAndInput
              title="보조 관리자"
              type="none"
              value={admin2Obj?.member_id || ""}
              placeholder="보조 관리자"
            />
            <TitleAndInput
              title="비밀번호"
              type="password"
              value={admin2Pw}
              onChange={(e) => setAdmin2Pw(e.target.value)}
              placeholder="보조 비밀번호"
            />
          </InputLinkBox>

          {/* <InputLinkBox>
            <TitleAndInput
              title="페이지당 게시물 수"
              type="number"
              placeholder="페이지당 게시물 수"
            />
          </InputLinkBox> */}
        </SettingBox>

        <SettingBox>
          <BoxButtonTitle>
            AI용 모델 API KEY
            <Btn type="button" title="저장" color="blue" onClick={apiPutClick} />
          </BoxButtonTitle>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle>gpt-4o-mini</InputTitle> */}
              <TitleAndInput
                title="API Key"
                type="textarea"
                value={apiKey || ""}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="API Key"
                score={true}
                inputWidth="40rem"
                height="6rem"
              />
            </FlexBox>
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle></InputTitle> */}
              <TitleAndInput
                title="model"
                type="text"
                value={modelVal}
                onChange={(e) => setModelVal(e.target.value)}
                placeholder="AI model 입력해주세요."
                score={true}
                inputWidth="40rem"
              />
            </FlexBox>
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle></InputTitle> */}
              <TitleAndInput
                title="prompt"
                type="textarea"
                value={promptVal}
                onChange={(e) => setPromptVal(e.target.value)}
                placeholder="AI prompt 입력해주세요."
                score={true}
                inputWidth="40rem"
                height="6rem"
              />
            </FlexBox>
          </InputLinkBox>

          {/* <InputLinkBox>
            <FlexBox>
              <InputTitle>과금현황</InputTitle>
              <TitleAndInput
                title="총 사용량"
                type="text"
                value="토큰"
                placeholder="토큰"
                disabled={true}
                score={true}
              />
            </FlexBox>

            <TitleAndInput
              title="환산비용"
              type="text"
              value="20USD"
              placeholder="환산비용"
              disabled={true}
              score={true}
            />
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              <InputTitle></InputTitle>
              <TitleAndInput
                title="일일 비용한도"
                type="text"
                value="130USB"
                placeholder="일일 비용한도"
                score={true}
              />
            </FlexBox>

            <TitleAndInput
              title="환산비용"
              type="text"
              value="100,000원"
              placeholder="환산비용"
              disabled={true}
              score={true}
            />
          </InputLinkBox> */}
        </SettingBox>
      </CommmonBoxLayout>
    </CommonLayout>
  );
}

const SettingBox = styled.div`
  height: calc(50vh - 8rem);
`;


// const SettingTitle = styled(CommonBoxTitle)`
//   margin-bottom: 2.5rem;
// `;

// const PhoneCheckBox = styled(FlexBox)`
//   ${flex};
//   gap: 0.75rem;
// `;